import { useRef } from "react";
import ModalPop from "./ModalPop";

const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      txt1: "유품정리 서비스",
      txt2: "돌아가신 고인의 유품을",
      txt3: "정성을 다해 정리해드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=54",
    },
    {
      img: "/images/service2.png",
      txt1: "고독사 유품정리 서비스",
      txt2: "홀로 돌아가신 현장을",
      txt3: "정성을 다해 정리해드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=57",
    },
    {
      img: "/images/service3.png",
      txt1: "빈집정리 서비스",
      txt2: "폐기물 및 기타 버려야하는 물건들이",
      txt3: "많은 집을 빈집으로 만들어드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=58",
    },
    {
      img: "/images/service4.png",
      txt1: "생전정리 서비스",
      txt2: "요양병원에 입원하신 부모님과 같이",
      txt3: "생전에 집을 비워드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=62",
    },
    {
      img: "/images/service5.png",
      txt1: "이민정리 서비스",
      txt2: "이민으로 인해 집을 정리해야하는 상황에",
      txt3: "집을 싹 비워드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=59",
    },
    {
      img: "/images/service6.png",
      txt1: "쓰레기집정리 서비스",
      txt2: "저장강박증 및 기타 쓰레기들로 가득찬",
      txt3: "집을 깨끗하게 치워드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=60",
    },
    {
      img: "/images/service7.png",
      txt1: "창고정리 서비스",
      txt2: "창고안에 있는 가전 및 가구와",
      txt3: "기타 폐기물들을 정리해드리는 서비스",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=61",
    },
    {
      img: "/images/service8.png",
      txt1: "폐기물처리 서비스",
      txt2: "간단한 폐기물처리부터 양이 많은",
      txt3: "대형 폐기물들까지 싹 정리해드립니다.",
      url: "https://blog.naver.com/PostList.naver?blogId=jewde101&from=postList&categoryNo=53",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:pb-36 bg-light"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-10"
      >
        <h2 className="font-medium">
          <span className="text-primary">싹!&nbsp;치워드림</span>에서는
          이러한&nbsp;서비스를&nbsp;제공합니다.
        </h2>
      </div>
      <div className=" relative w-full h-[1px] max-w-[1600px] mx-auto bg-black opacity-5 mb-5 xl:mb-10"></div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-6">
        {serviceList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full p-3 border rounded-sm shadow-2xl grid lg:grid-cols-3 bg-white"
          >
            <div className="relative w-full h-52 xl:h-60 rounded-md overflow-hidden">
              <img
                className="!relative w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                alt={v.txt1}
                src={v.img}
                width={400}
                height={400}
              />
            </div>
            <div className="lg:col-span-2 relative w-full h-full grid grid-rows-4 gap-1 px-3 py-4 lg:py-1">
              <h5 className="text-primary font-medium">SERVICE 0{i + 1}.</h5>
              <div className=" row-span-2">
                <h3 className="font-medium text-2xl lg:text-3xl">{v.txt1}</h3>
                <p className="lg:text-lg">{v.txt2}</p>
                <p className="lg:text-lg leading-none lg:leading-normal">
                  {v.txt3}
                </p>
              </div>
              <div className=" relative w-full grid grid-cols-2 items-end gap-3">
                <button
                  type="button"
                  onClick={() => window.open(v.url)}
                  className=" relative w-full h-fit bg-black text-white pt-2 pb-1"
                >
                  <h4 className="font-medium text-xl lg:text-2xl">작업사례</h4>
                </button>
                <button
                  type="button"
                  onClick={openfunc}
                  className=" relative w-full h-fit bg-primary text-point pt-2 pb-1"
                >
                  <h4 className="font-medium text-xl lg:text-2xl">문의하기</h4>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
